import ClientsAxios from '../client-axios';
import { ForgotPassword, LoginRequest } from '../dto/request';
import { LoginResponse, ResponseEntity } from '../dto/response';
import { EmptyResponse } from '../dto/response/common_Type';

const { API_SERVER } = ClientsAxios;
export const logoutService = async (payload: any) => {
    const responseEntity = new ResponseEntity<EmptyResponse>()
    try {
        const response = await API_SERVER.post('logout', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.Message, response?.data?.body ?? {})
    }
    return responseEntity
}

export const loginService = async (payload: LoginRequest) => {
    const responseEntity = new ResponseEntity<LoginResponse>()
    try {
        const response = await API_SERVER.post('login', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const ForgotPasswordService = async (payload: ForgotPassword) => {
    const responseEntity = new ResponseEntity<LoginResponse>()
    try {
        const response = await API_SERVER.post('password/forgot', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}


export const FetchRoleListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('roles/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const GetCaptchImageService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.get('captcha/get', payload)
        console.log(response.data.body)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.message, response?.data?.body ?? {})
    }
    return responseEntity
}


//verify-otp


export const VerifyLoginOTPService = async (payload: any) => {
    const responseEntity = new ResponseEntity<LoginResponse>()
    try {
        const response = await API_SERVER.post('verify-otp', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const OtpResendService = async (payload: { username: string }) => {
    const responseEntity = new ResponseEntity<EmptyResponse>()
    try {
        const response = await API_SERVER.post('resend-otp', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response ?? {};
        responseEntity.error(response?.StatusCode ?? 500, error?.message, response?.data?.body ?? {})
    }
    return responseEntity
}

export const RolesPermissionsService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('user-role-permissions', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const ResetPasswordService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('password/reset', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const ChangeUserPasswordService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('change-password', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}